export const API_POST_PAYMENT = "API_POST_PAYMENT";
export const API_POST_PAYMENT_SUCCESS = "API_POST_PAYMENT_SUCCESS";
export const API_POST_PAYMENT_FAIL = "API_POST_PAYMENT_FAIL";

export const API_GET_FOLDER_IS_PAID = "API_GET_FOLDER_IS_PAID";
export const API_GET_FOLDER_IS_PAID_SUCCESS = "API_GET_FOLDER_IS_PAID_SUCCESS";
export const API_GET_FOLDER_IS_PAID_FAIL = "API_GET_FOLDER_IS_PAID_FAIL";
export const API_POST_PAY_LOG = "API_POST_PAY_LOG";

export const API_GET_FOLDER_PAYMENT_CANCEL = "API_GET_FOLDER_PAYMENT_CANCEL";
export const API_GET_FOLDER_PAYMENT_CANCEL_SUCCESS = "API_GET_FOLDER_PAYMENT_CANCEL_SUCCESS";
export const API_GET_FOLDER_PAYMENT_CANCEL_FAIL = "API_GET_FOLDER_PAYMENT_CANCEL_FAIL";

export const API_GET_TERMINALS = "API_GET_TERMINALS";
export const API_GET_TERMINALS_SUCCESS = "API_GET_TERMINALS_SUCCESS";
export const API_GET_TERMINALS_FAIL = "API_GET_TERMINALS_FAIL";

export const API_GET_PAYMENTS_FOR_USER = "API_GET_PAYMENTS_FOR_USER";
export const API_GET_PAYMENTS_FOR_USER_SUCCESS = "API_GET_PAYMENTS_FOR_USER_SUCCESS";
export const API_GET_PAYMENTS_FOR_USER_FAIL = "API_GET_PAYMENTS_FOR_USER_FAIL";

export const API_POST_FOLDER_PAYMENT_REF = "API_POST_FOLDER_PAYMENT_REF";
export const API_POST_FOLDER_PAYMENT_REF_SUCCESS = "API_POST_FOLDER_PAYMENT_REF_SUCCESS";
export const API_POST_FOLDER_PAYMENT_REF_FAIL = "API_POST_FOLDER_PAYMENT_REF_FAIL";

export const API_GET_PAYMENTS_FOR_EXCELL = "API_GET_PAYMENTS_FOR_EXCELL";

export const API_GET_CASING_PAYMENT_CANCEL = "API_GET_CASING_PAYMENT_CANCEL";
export const API_GET_CASING_PAYMENT_CANCEL_SUCCESS = "API_GET_CASING_PAYMENT_CANCEL_SUCCESS";
export const API_GET_CASING_PAYMENT_CANCEL_FAIL = "API_GET_CASING_PAYMENT_CANCEL_FAIL";
